(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-inline"] && !Shopify.designMode) return;
  try {
    // Function to change the dynamic placeholder text
  function changePlaceholderText() {
    const texts = ["\"Medicine\"", "\"Personal Care\"", "\"Baby Care\""];
    let index = 0;

    setInterval(function() {
      document.querySelector('.search-dynamic-text').innerText = texts[index];
      index = (index + 1) % texts.length;
    }, 2000); // Change every 2 seconds
  }

  // Initialize placeholder text change when the page is ready
  document.addEventListener("DOMContentLoaded", function() {
    changePlaceholderText();
  });
  } catch(e) { console.error(e); }
})();

})();
